import { gql } from '@apollo/client';

export const ResultHistoriesQuery = gql`
  query(
    $entityId: Int!
    $entityClass: String!
  ) {
    ResultHistories(entityId: $entityId, entityClass: $entityClass) {
      entityId
      entityClass
      userId
      userName
      result
      createdAt
    }
  }
`;
